export default "__VITE_ASSET__CFDJUcmq__"